/*
 * @Description: 权限相关录音
 * @Date: 2019-01-31 13:40:13
 * @LastEditors: sillyy
 * @LastEditTime: 2019-01-31 16:34:42
 */
export default [
  {
    name: 'login',
    path: '/login',
    component: () => import('@/views/login/index.vue')
  }
];
